module.exports = __webpack_public_path__ + "img/23.c7df757d.jpg";